import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { Itutorial, ItutorialSingle } from "../models/tutorial-interface";

@Injectable({
  providedIn: "root",
})
export class TutorialService {
  public video_to_play: string;
  public force_open_modal: boolean = false;

  constructor(private _httpClient: HttpClient) {}

  openTutorial(name: string) {
    this.video_to_play = name;
    this.force_open_modal = true;
  }

  async getList() {
    return this._httpClient.get<Itutorial[]>("/tutorial").toPromise();
  }

  async getTutorial(id: string) {
    return this._httpClient.get<ItutorialSingle>("/tutorial/" + id).toPromise();
  }

  async updateTutorial(id: number, data: { title: string; description: string }) {
    return this._httpClient.put("/tutorial/" + id, data).toPromise();
  }

  async createTutorial(data: { title: string; description: string }) {
    return this._httpClient.post("/tutorial", data).toPromise();
  }

  async deleteTutorial(id: number) {
    return this._httpClient.delete("/tutorial/" + id).toPromise();
  }

  async uploadVideos(files, id: number) {
    const formData: FormData = new FormData();
    for (let file of files) {
      formData.append("file[]", file);
    }

    const req = new HttpRequest("POST", `/tutorial/videos/${id}`, formData);
    return this._httpClient.request(req).toPromise();
  }

  async deleteVideo(id: number, format: string) {
    return this._httpClient.delete(`/tutorial/video/${id}/${format}`).toPromise();
  }
}
